/**
 * Copyright 2023 Design Barn Inc.
 */

import { Button, ModalHeader, ModalTitle } from '@lottiefiles/ds-core';
import { usePathname, useRouter } from 'next/navigation';
import React, { useCallback } from 'react';

import { ChevronLeftIcon } from '../icons';

const basePaths = [
  `${process.env['NEXT_PUBLIC_BASE_PATH']}/register`,
  `${process.env['NEXT_PUBLIC_BASE_PATH']}/login`,
  `${process.env['NEXT_PUBLIC_BASE_PATH']}/verify-email`,
];

export default function CardHeader(): React.ReactElement {
  const pathname = usePathname();
  const router = useRouter();

  // eslint-disable-next-line react-perf/jsx-no-jsx-as-prop
  const backIcon = <ChevronLeftIcon />;

  let showBackButton = false;
  let title = 'Log in';

  if (pathname.includes('/register')) {
    title = 'Create an account';
  } else if (pathname.includes('/login/enterprise')) {
    title = 'Enterprise log in';
  } else if (pathname.includes('/verify-email')) {
    title = 'Verify your email';
  }

  if (!basePaths.includes(`${process.env['NEXT_PUBLIC_BASE_PATH']}${pathname}`)) {
    showBackButton = true;
  }

  const onBackClick = useCallback(() => {
    router.back();
  }, [router]);

  return (
    <ModalHeader className="flex justify-center p-6">
      {showBackButton && (
        <Button onClick={onBackClick} variant="ghost" size="sm" className="absolute left-8 p-1" iconLeft={backIcon}>
          Back
        </Button>
      )}
      <ModalTitle className="text-2xl">{title}</ModalTitle>
    </ModalHeader>
  );
}
